import { render, staticRenderFns } from "./CardEnvioLaboratorios.vue?vue&type=template&id=4e2d53cf"
import script from "./CardEnvioLaboratorios.vue?vue&type=script&lang=js"
export * from "./CardEnvioLaboratorios.vue?vue&type=script&lang=js"
import style0 from "./CardEnvioLaboratorios.vue?vue&type=style&index=0&id=4e2d53cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports